// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a4a1b54","455":"45d37dab","822":"0fcd47aa","947":"34233505","977":"f76d8a73"}[chunkId] + ".chunk.js";
};